export default __webpack_public_path__ + "static/media/tensorflow.b52d5111.svg";